import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/app-landing/landing').then((m) => m.LandingComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
